import { render, staticRenderFns } from "./ProfileTabsSix.vue?vue&type=template&id=2ec88f0a&scoped=true&"
import script from "./ProfileTabsSix.vue?vue&type=script&lang=js&"
export * from "./ProfileTabsSix.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTabsSix.vue?vue&type=style&index=0&id=2ec88f0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec88f0a",
  null
  
)

export default component.exports